import React from "react";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import MapViewTable from "./MapViewTable";
import MapViewDeleteModal from "./MapViewDeleteModal";
// AUTHORIZATION
import { useScreenPermission } from "../../../customHooks/useScopedPermission";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";
// STYLES
import "./styles.css";

const MapViewPage = () => {
  // ************************************************ */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const { theme } = useSelector((state: RootState) => state.home);
  // Reads SCREEN_PERMISSION["map-view"] -- the same declaration Layout.tsx's
  // sidebar link reads.
  const allowed = useScreenPermission("map-view");

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {allowed ? (
        <div className={`layout__contentPage__${theme}`}>
          <MapViewTable />
          <MapViewDeleteModal />
        </div>
      ) : (
        <UnauthorizedPage />
      )}
    </div>
  );
};

export default MapViewPage;
